<template>
  <div class="card" ref="parentCodes">
    <header class="card-header has-background-dark">
      <p class="card-header-title has-text-light">PARENT CODES</p>
    </header>
    <div class="card-content scrollable">
      <div class="content">
        <b-field>
          <base-select
            :service="$options.codeService"
            fetch-func="listTypes"
            label="Type"
            :value.sync="filters.type"
            value-key="type"
            label-key="type"
          />
        </b-field>
        <b-field>
          <b-button type="is-link" expanded @click.prevent="onFilter">FILTER</b-button>
        </b-field>
        <div class="columns m-t-20">
          <div class="column">
            <!-- <parent-codes-table
              :params="filters"
              :height="mainBoxHeight"
              :selected.sync="selected"
              :checked.sync="checked"
              :codes="codes"
              ref="codesTable"
            />-->
            <b-table
              :data="codes"
              :columns="$options.columns"
              :checked-rows.sync="checked"
              checkable
              :loading="loading"
            >
              <template slot-scope="props">
                <b-table-column field="code" label="Code">{{ props.row.code }}</b-table-column>
                <b-table-column field="name" label="Name">{{ props.row.name }}</b-table-column>
                <b-table-column field="group" label="Group">{{ props.row.group }}</b-table-column>
                <b-table-column field="type" label="Type">{{ props.row.type }}</b-table-column>
                <b-table-column field="id" label>
                  <b-button size="is-small" @click.prevent="viewChild(props.row)">View Child</b-button>
                </b-table-column>
              </template>
            </b-table>
          </div>
        </div>
      </div>
    </div>
    <footer class="card-footer">
      <p class="card-footer-item">
        <b-button
          type="is-dark"
          expanded
          @click.prevent="onAssign"
          :disabled="assigning || checked.length == 0"
        >ASSIGN CODES</b-button>
      </p>
    </footer>

    <!-- View Childs Modal -->
    <b-modal :active.sync="isViewChild" trap-focus aria-role="dialog" aria-modal>
      <viewChildModal :code="isViewCode"/>
    </b-modal>
  </div>
</template>
<script>
import BaseSelect from "@/components/partials/BaseSelect";
import { CodeService } from "@/services/code.service";
import viewChildModal from "./viewChildModal";
import { JsonDenormalizer } from "@/helpers/JsonDenormalizer";

export default {
  codeService: CodeService,
  components: {
    BaseSelect,
    viewChildModal
  },
  props: [ 'firm' ],
  columns: [
    {
      field: "code",
      label: "Code"
    },
    {
      field: "name",
      label: "Name"
    },
    {
      field: "group",
      label: "Group"
    },
    {
      field: "type",
      label: "Type"
    }
  ],
  data: () => ({
    fullHeight: 0,
    filters: { type: null },
    checked: [],
    assigning: false,
    isViewChild: false,
    isViewCode: null,
    codes: [],
    loading: false
  }),
  computed: {
    mainBoxHeight() {
      const spacesOnTop = 220; // Filters box bot nargin
      return this.fullHeight - spacesOnTop;
    }
  },
  watch: {
    checked: {
      deep: true,
      handler: function() {
        this.$nextTick(() => {
          this.$emit("update:parentCodechecked", this.checked);
        });
      }
    }
  },
  mounted() {
    this.fullHeight = this.$refs.parentCodes.clientHeight;
    this.fetchCodes();
  },
  methods: {
    async fetchCodes(filter) {
      const params = filter ? filter : {};
      params.firm_firm_id = this.firm.id
      params.active = 1
      this.loading = true;
      this.codes = await this.$options.codeService
        .all(params)
        .then(response => JsonDenormalizer.denormalize(response));
      this.loading = false;
    },
    onFilter() {
      this.$nextTick(async () => {
        this.fetchCodes(this.filters.type ? this.filters : null);
      });
    },
    onAssign() {
      this.assigning = true;
      this.$emit("assignCodes");
    },
    viewChild(code) {
      this.isViewChild = true;
      this.isViewCode = code;
    }
  }
};
</script>
<style scoped>
.scrollable {
  height: calc(84vh - 50px);
}

.m-t-20 {
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/codeConfigurator/partials/parentCodes.vue